import React from 'react'
import usePages from '@hooks/Pages/usePages'

type DynamicComponentTypes = {
  component: {
    type_id: string
    data: any
    regions: any[]
    custom: any
  }
  className?: string
  index?: number
}

const DynamicComponent = ({
  component,
  className,
  index,
  ...rest
}: DynamicComponentTypes) => {
  const pages = usePages()
  const componentMapping = pages.componentMapping

  if (
    componentMapping &&
    typeof componentMapping[component.type_id] !== 'undefined'
  ) {
    return React.createElement(componentMapping[component.type_id], {
      data: component.data,
      regions: component.regions,
      custom: component.custom,
      index,
      className,
      ...rest
    })
  }

  return React.createElement(() => (
    <div>The component {component.type_id} has not been created yet.</div>
  ))
}

export default DynamicComponent
